// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"e55b334f","763":"ea291cd2","787":"2cda5969"}[chunkId] + ".chunk.js";
};